<div class="guard">
  @if (this.isGuardValid()) {
    <div class="guard-valid">
      <ng-content></ng-content>
    </div>
  }
  @if (!this.isGuardValid() && this.canDisplayErrorMessage()) {
    <div class="guard-no-valid">
      <cam-picture-info-message icon="lock" iconSize="lg" text="ui.guard.content"></cam-picture-info-message>

      @if (this.level() === 'authenticated') {
        <cam-button (action)="this.goToLogin()">{{ 'user.login' | translate }}</cam-button>
      }
    </div>
  }
</div>
